import { Logo } from "./Logo.js";

/**
 * The frame of a page a person reaches WITHOUT a session — the same one sign-in, sign-up and the
 * password screens draw, so a client arriving from an agency's link or back from Shopify lands on
 * something recognisably Ecomally.
 */
export function PublicPage({ children, wide = false }: { readonly children: React.ReactNode; readonly wide?: boolean }): React.JSX.Element {
  return (
    <main className="relative flex min-h-svh items-center justify-center overflow-hidden bg-(--page) px-4 py-10">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -right-24 size-96 rounded-full bg-amber-400 opacity-20 blur-3xl" />
        <div className="absolute -bottom-24 -left-24 size-96 rounded-full bg-blue-500 opacity-20 blur-3xl" />
      </div>
      <div className="absolute top-8 left-8 z-10">
        <Logo className="h-7 w-auto" />
      </div>
      <div className={`bg-card relative w-full rounded-2xl border p-8 shadow-xl ${wide ? "max-w-md" : "max-w-sm"}`}>{children}</div>
    </main>
  );
}
